import { Routes } from '@angular/router';

export const routes: Routes = [
	{
		path: '',
		loadComponent: () =>
			import('./components/section-list/section-list.component').then(
				(component) => component.SectionsListComponent
			)
	}
];
